import React from 'react';
import { StyleSheet } from 'react-native';
import { DRNText } from '@traveloka/district-ui';

import R from 'common/res/R';

const styles = StyleSheet.create({
  content: {
    color: R.color.textSecondary,
    paddingHorizontal: R.spacing.xxl,
  },
});

export default ({ children, ...props }) => (
  <DRNText style={styles.content} {...props}>
    {children}
  </DRNText>
);
